import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const UNITA = ["cad", "pz", "mq", "ml", "mc", "kg", "q", "t", "lt", "sacchi", "conf", "a corpo"];
export const emptyRiga = () => ({ codice: "", descrizione: "", unita: "cad", quantita: 1 });

export const DdtLines = ({ righe, onChange }) => {
  const upd = (i, patch) => onChange(righe.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  const units = (u) => (UNITA.includes(u) || !u ? UNITA : [u, ...UNITA]);
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>Beni trasportati</Label>
        <Button type="button" size="sm" variant="outline" onClick={() => onChange([...righe, emptyRiga()])} data-testid="ddt-add-line-button">
          <Plus className="w-4 h-4 mr-1" /> Aggiungi riga
        </Button>
      </div>
      {righe.map((r, i) => (
        <div key={i} className="grid grid-cols-[1fr_1fr_1fr_40px] sm:grid-cols-[84px_1fr_110px_90px_40px] gap-2 items-start rounded-lg border border-border p-2 bg-secondary/30" data-testid={`ddt-line-${i}`}>
          <Input value={r.codice || ""} onChange={(e) => upd(i, { codice: e.target.value })} placeholder="Cod." className="h-9 text-xs" />
          <Textarea value={r.descrizione} onChange={(e) => upd(i, { descrizione: e.target.value })} rows={1} placeholder="Descrizione dei beni" className="col-span-4 sm:col-span-1 order-first sm:order-none min-h-[36px] text-sm" data-testid={`ddt-line-desc-${i}`} />
          <Select value={r.unita || "cad"} onValueChange={(u) => upd(i, { unita: u })}>
            <SelectTrigger className="h-9 text-xs"><SelectValue /></SelectTrigger>
            <SelectContent>{units(r.unita).map((u) => <SelectItem key={u} value={u}>{u}</SelectItem>)}</SelectContent>
          </Select>
          <Input type="number" min="0" step="any" value={r.quantita} onChange={(e) => upd(i, { quantita: e.target.value })} className="h-9" data-testid={`ddt-line-qty-${i}`} />
          <Button type="button" variant="ghost" size="icon" className="text-muted-foreground hover:text-destructive" onClick={() => onChange(righe.filter((_, idx) => idx !== i))} data-testid={`ddt-line-remove-${i}`}>
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default DdtLines;
